import { useState, useCallback } from 'react';

const useToggle = (initialValue = false): [boolean, (value?: boolean) => void] => {
  const [state, setState] = useState<boolean>(initialValue);

  const toggle = useCallback((value?: boolean) => {
    if (typeof value === 'boolean') {
      setState(value)
    } else {
      setState(prevState => !prevState);
    }
  }, []);

  return [state, toggle];
};

export default useToggle;